import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart6: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconChart6"><Path d="M17.5 3.00098C16.6716 3.00098 16 3.67255 16 4.50098V19.5H14.5V10.001C14.5 9.17255 13.8284 8.50098 13 8.50098H11C10.1716 8.50098 9.5 9.17255 9.5 10.001V19.5H8V15.501C8 14.6725 7.32843 14.001 6.5 14.001H4.5C3.67157 14.001 3 14.6725 3 15.501V19.5H1.75C1.33579 19.5 1 19.8358 1 20.25C1 20.6642 1.33579 21 1.75 21H22.25C22.6642 21 23 20.6642 23 20.25C23 19.8358 22.6642 19.5 22.25 19.5H21V4.50098C21 3.67255 20.3284 3.00098 19.5 3.00098H17.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChart6;
